import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Card } from "../common/Card";
import { MRRPieChartShimmer } from "../../common/reportDashBShimmer/MRRPieChartShimmer";
import { DailyRevenueShimmer } from "../../common/reportDashBShimmer/DailyRevenueShimmer";
import { SUBSCRIPTION_CHART_COLORS } from "./subscriptionReportUtils";

export function SubscriptionPlanChartsSection({
  loading,
  revenueByPlan,
  planDistribution,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
        <span className="mb-6 text-[#1A1A1A] text-lg">
          MRR by Subscription Plan
        </span>
        {loading ? (
          <MRRPieChartShimmer segments={6} />
        ) : revenueByPlan.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={revenueByPlan}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                label={({ name, percentage }) => `${name} ${percentage}%`}
              >
                {revenueByPlan.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      SUBSCRIPTION_CHART_COLORS[
                        index % SUBSCRIPTION_CHART_COLORS.length
                      ]
                    }
                  />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                }}
                formatter={(value) => `$${value.toLocaleString()}`}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-gray-500">
            No data available
          </div>
        )}
      </Card>

      <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
        <span className="mb-6 text-[#1A1A1A] text-lg">Plan Distribution</span>
        {loading ? (
          <DailyRevenueShimmer />
        ) : planDistribution.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={planDistribution}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis dataKey="plan" stroke="#6B7280" />
              <YAxis stroke="#6B7280" />
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                }}
              />
              <Bar
                dataKey="subscribers"
                fill="#1E61DC"
                radius={[4, 4, 0, 0]}
                name="Subscribers"
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex justify-center items-center h-64 text-gray-400">
            No data available
          </div>
        )}
      </Card>
    </div>
  );
}
